import React, { useState } from "react";
import { toast } from "react-toastify";
import SelectDropDown from "@/components/Common/SelectDropDown";
import { PICKER_STYLES } from "@/helpers/pickerStyles";

const statusOf = (source) =>
  source === "roster" ? "" : source === "staff" || source === "gitcha" ? "Added by Gitcha" : "Invited";

const Picker = ({ id, placeholder, options, disabled, onPick, onClose }) => (
  <div className="brokerage-studio__picker">
    <SelectDropDown
      id={id}
      className="brokerage-studio__select"
      classNamePrefix="select"
      placeholder={placeholder}
      options={options}
      value={null}
      disabled={disabled}
      styles={PICKER_STYLES}
      errorClass="d-none"
      onChange={(option) => option && onPick(option.value)}
    />
    <button type="button" className="brokerage-studio__link" onClick={onClose}>
      Cancel
    </button>
  </div>
);

export const PageEditors = ({ data, addManager, removeManager }) => {
  const [adding, setAdding] = useState(false);
  return (
    <section className="content-block">
      <div className="title-sec">
        <h4>Who can edit</h4>
        {data.invitable.length && !adding ? (
          <a role="button" tabIndex={0} onClick={() => setAdding(true)} onKeyDown={(event) => event.key === "Enter" && setAdding(true)}>
            Add someone
          </a>
        ) : null}
      </div>
      <p className="brokerage-studio__hint">
        Principal brokers and office managers on the MLS roster can always edit. People you add lose access if they
        leave the&nbsp;roster.
      </p>
      <ul className="brokerage-studio__list">
        {data.admins.map((admin) => {
          const status = statusOf(admin.source);
          const removable = admin.source === "broker" || admin.source === "invite";
          return (
            <li key={`${admin.source}-${admin.userId}`}>
              <span className="brokerage-studio__name">{admin.name}</span>
              {status || removable ? (
                <span className="brokerage-studio__row-tools">
                  {status ? <span className="brokerage-studio__status">{status}</span> : null}
                  {removable ? (
                    <button
                      type="button"
                      className="brokerage-studio__link"
                      aria-label={`Remove ${admin.name}`}
                      disabled={removeManager.isPending}
                      onClick={() => removeManager.mutate(admin.userId, { onError: (error) => toast.error(error.message) })}
                    >
                      Remove
                    </button>
                  ) : null}
                </span>
              ) : null}
            </li>
          );
        })}
      </ul>
      {adding && data.invitable.length ? (
        <Picker
          id="brokerage-add-editor"
          placeholder="Search people in your office"
          options={data.invitable.map((member) => ({ value: member.userId, label: member.name }))}
          disabled={addManager.isPending}
          onPick={(userId) => {
            setAdding(false);
            addManager.mutate(userId, {
              onSuccess: () => toast.success("They can now edit your brokerage page."),
              onError: (error) => toast.error(error.message),
            });
          }}
          onClose={() => setAdding(false)}
        />
      ) : null}
    </section>
  );
};
